<template>
  <vetalfa-dialog
    v-on:dialogClose="closeModel"
    :title="topicName"
    :bottom="false"
    :toggleModel="topicsModel"
    :fullscreen="false"
    max-width="300px"
  >
    <v-container fluid class="overflow-y-auto" style="height: 200px">
      <v-row class="ma-0 pa-0" align="start" justify="center">
        <v-col
          @click="getSubtopic(subtopic)"
          v-for="subtopic in subtopics"
          :key="subtopic.collection || subtopic.name"
          cols="12"
          class="pa-0 ma-0 pb-2 drugs-info-navigation-item"
        >
          <v-card elevation="1" height="40px">
            <v-row
              class="ma-0 pa-0"
              align="center"
              justify="center"
              style="height: 40px"
            >
              <p class="pa-0 ma-0 py-1 text-center">
                {{ subtopic.portugueseName || subtopic.name }}
              </p>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </vetalfa-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "Topics",
  methods: {
    ...mapActions("general", ["routePathRedirect"]),
    ...mapMutations("topics", ["setTopicsModel"]),
    getSubtopic(subtopic) {
      this.closeModel();
      let path = "/items";
      if (this.isCategoryTopic) {
        path += `?category=${subtopic.id}`;
      } else {
        path += `/subtopics/${subtopic.id}`;
      }
      this.routePathRedirect({ path });
    },
    closeModel() {
      this.setTopicsModel(false);
    },
  },
  watch: {},
  computed: {
    ...mapGetters("topics", [
      "subtopics",
      "isCategoryTopic",
      "topicsModel",
      "topic",
    ]),
    topicName() {
      return !!this.topic ? this.topic.name : "";
    },
  },
  data() {
    return {};
  },
  mounted() {},
  created() {},
};
</script>